"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _PriceChange = _interopRequireDefault(require("../components/PriceChange"));

var _Loading = _interopRequireDefault(require("../components/Loading"));

var _order = require("@/api/order");

var _validate = require("@/utils/validate");

var _dialog = require("@/libs/dialog");

var _utils = require("@/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = {
  name: "AdminOrderList",
  components: {
    PriceChange: _PriceChange.default,
    Loading: _Loading.default
  },
  props: {},
  data: function data() {
    return {
      isWriteOff: (0, _utils.isWriteOff)(),
      current: "",
      change: false,
      types: 0,
      where: {
        page: 1,
        limit: 10,
        status: 'unPaid'
      },
      list: [],
      loaded: false,
      loading: false,
      orderInfo: {},
      status: null
    };
  },
  watch: {
    "$route.params.types": function $routeParamsTypes(newVal) {
      var that = this;

      if (newVal != undefined) {
        that.where.status = newVal;
        that.init();
      }
    },
    types: function types() {
      this.getIndex();
    }
  },
  created: function created() {
    Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/assets/js/media_750'));
    });
  },
  mounted: function mounted() {
    var _this = this;

    this.where.status = this.$route.params.types;
    this.current = "";
    this.getIndex();
    this.$scroll(this.$refs.container, function () {
      !_this.loading && _this.getIndex();
    });
  },
  methods: {
    more: function more(index) {
      if (this.current === index) this.current = "";else this.current = index;
    },
    modify: function modify(item, status) {
      this.change = true;
      this.orderInfo = item;
      this.status = status;
    },
    changeclose: function changeclose(msg) {
      this.change = msg;
      this.init();
    },
    // 拒绝退款
    getRefuse: function getRefuse(id, reason) {
      var _this2 = this;

      (0, _order.orderRefuseApi)({
        orderNo: id,
        reason: reason
      }).then(function () {
        _this2.change = false;

        _this2.$dialog.success("已拒绝退款");

        _this2.init();
      }).catch(function (error) {
        _this2.$dialog.error(error.message);
      });
    },
    savePrice: function () {
      var _savePrice = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(opt) {
        var that, data, price, refundPrice, refundStatus, remark;
        return _index.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this, data = {}, price = opt.price, refundPrice = opt.refundPrice, refundStatus = that.orderInfo.refundStatus, remark = opt.remark;

                if (!(that.status == 0 && refundStatus === 0)) {
                  _context.next = 15;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return this.$validator({
                  price: [(0, _validate.required)(_validate.required.message("金额"))]
                }).validate({
                  price: price
                });

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", (0, _dialog.validatorDefaultCatch)(_context.t0));

              case 10:
                data.price = price;
                data.orderNo = opt.orderId;
                (0, _order.editPriceApi)(data).then(function () {
                  that.change = false;
                  that.$dialog.success("改价成功");
                  that.init();
                }).catch(function (error) {
                  that.$dialog.error(error.message);
                });
                _context.next = 41;
                break;

              case 15:
                if (!(that.status == 0 && refundStatus === 1)) {
                  _context.next = 30;
                  break;
                }

                _context.prev = 16;
                _context.next = 19;
                return this.$validator({
                  refundPrice: [(0, _validate.required)(_validate.required.message("金额")), (0, _validate.num)(_validate.num.message("金额"))]
                }).validate({
                  refundPrice: refundPrice
                });

              case 19:
                _context.next = 24;
                break;

              case 21:
                _context.prev = 21;
                _context.t1 = _context["catch"](16);
                return _context.abrupt("return", (0, _dialog.validatorDefaultCatch)(_context.t1));

              case 24:
                data.amount = refundPrice;
                data.type = opt.type;
                data.orderNo = opt.orderId;
                (0, _order.orderRefundApi)(data).then(function (res) {
                  that.change = false;
                  that.$dialog.success('退款成功');
                  that.init();
                }, function (err) {
                  that.change = false;
                  that.$dialog.error(err.message);
                });
                _context.next = 41;
                break;

              case 30:
                _context.prev = 30;
                _context.next = 33;
                return this.$validator({
                  remark: [(0, _validate.required)(_validate.required.message("备注"))]
                }).validate({
                  remark: remark
                });

              case 33:
                _context.next = 38;
                break;

              case 35:
                _context.prev = 35;
                _context.t2 = _context["catch"](30);
                return _context.abrupt("return", (0, _dialog.validatorDefaultCatch)(_context.t2));

              case 38:
                data.mark = remark;
                data.orderNo = opt.orderId;
                (0, _order.orderMarkApi)(data).then(function (res) {
                  that.change = false;
                  that.$dialog.success('提交成功');
                  that.init();
                }, function (err) {
                  that.change = false;
                  that.$dialog.error(err.message);
                });

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 7], [16, 21], [30, 35]]);
      }));

      function savePrice(_x) {
        return _savePrice.apply(this, arguments);
      }

      return savePrice;
    }(),
    init: function init() {
      this.list = [];
      this.where.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getIndex();
      this.current = "";
    },
    getIndex: function getIndex() {
      var _this3 = this;

      if (this.loading || this.loaded) return;
      this.loading = true;
      (0, _order.orderListApi)(this.where).then(function (res) {
        _this3.loading = false;
        _this3.loaded = res.list.length < _this3.where.limit;

        _this3.list.push.apply(_this3.list, res.list);

        _this3.where.page = _this3.where.page + 1;
      }, function (err) {
        _this3.$dialog.error(err.message);
      });
    },
    changeStatus: function changeStatus(val) {
      if (this.where.status != val) {
        this.where.status = val;
        this.init();
      }
    },
    toDetail: function toDetail(item) {
      this.$router.push({
        path: "/javaMobile/orderDetail/" + item.orderId
      });
    },
    offlinePay: function offlinePay(item) {// setOfflinePay({ order_id: item.order_id }).then(
      //   res => {
      //     this.$dialog.success(res.message);
      //     this.init();
      //   },
      //   error => {
      //     this.$dialog.error(error.message);
      //   }
      // );
    }
  }
};
exports.default = _default;